import { createFileRoute } from '@tanstack/react-router';

import { AdminGmailMailboxesPage } from '@pages/admin';

export const Route = createFileRoute(
  '/$locale/_authenticated/admin/settings/operations/integrations/gmail'
)({ component: AdminGmailMailboxesPage });
